export default {
  nav: {
    platform: '\u30d7\u30e9\u30c3\u30c8\u30d5\u30a9\u30fc\u30e0',
    aiAgents: 'AI\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8',
    features: '\u6a5f\u80fd',
    developers: '\u958b\u767a\u8005',
    roadmap: '\u30ed\u30fc\u30c9\u30de\u30c3\u30d7',
    launchApp: '\u30a2\u30d7\u30ea\u3092\u8d77\u52d5',
    lightMode: '\u30e9\u30a4\u30c8\u30e2\u30fc\u30c9',
    darkMode: '\u30c0\u30fc\u30af\u30e2\u30fc\u30c9',
  },
  hero: {
    badge: '\u30e1\u30a4\u30f3\u30cd\u30c3\u30c8\u751f\u914d\u4e2d',
    title1: 'AI\u30cd\u30a4\u30c6\u30a3\u30d6',
    title2: '\u53d6\u5f15\u30a4\u30f3\u30d5\u30e9',
    subtitle:
      '\u5b8c\u5168\u30aa\u30f3\u30c1\u30a7\u30fc\u30f3\u306e\u30d1\u30fc\u30da\u30c1\u30e5\u30a2\u30eb\u3001AI\u5b9f\u884c\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8\u3001\u4e88\u6e2c\u5e02\u5834\u3001\u30ea\u30a2\u30eb\u30bf\u30a4\u30e0\u6d41\u52d5\u6027\u2014\u3059\u3079\u3066\u304c\u7d71\u5408\u30d7\u30e9\u30c3\u30c8\u30d5\u30a9\u30fc\u30e0\u306b\u3002',
    startTrading: '\u53d6\u5f15\u3092\u59cb\u3081\u308b',
    launchAgent: '\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8\u3092\u8d77\u52d5',
    apiDocs: 'API\u30c9\u30ad\u30e5\u30e1\u30f3\u30c8',
    volume24h: '24H\u53d6\u5f15\u91cf',
    activeTraders: '\u30a2\u30af\u30c6\u30a3\u30d6\u30c8\u30ec\u30fc\u30c0\u30fc',
    uptime: '\u52d5\u4f5c\u7387',
    terminalName: 'zhisu-terminal',
    live: '\u30e9\u30a4\u30d6',
    oi: '\u672a\u6c7a\u6e08\u5efa\u7389',
    funding: '\u8cc7\u91d1\u8abf\u9054\u7387',
    spread: '\u30b9\u30d7\u30ec\u30c3\u30c9',
    aiActive: 'AI\u6d3b\u6027\u4e2d',
    liveTrades: '\u30e9\u30a4\u30d6\u53d6\u5f15',
    realtime: '\u30ea\u30a2\u30eb\u30bf\u30a4\u30e0',
    long: '\u30ed\u30f3\u30b0',
    short: '\u30b7\u30e7\u30fc\u30c8',
  },
  metrics: {
    realtimeMetrics: '\u30ea\u30a2\u30eb\u30bf\u30a4\u30e0\u6307\u6a19',
    platformGlance: '\u30d7\u30e9\u30c3\u30c8\u30d5\u30a9\u30fc\u30e0\u6982\u89b3',
    volume24h: '24H\u53d6\u5f15\u91cf',
    openInterest: '\u672a\u6c7a\u6e08\u5efa\u7389',
    activeTraders: '\u30a2\u30af\u30c6\u30a3\u30d6\u30c8\u30ec\u30fc\u30c0\u30fc',
    aiExecutions: 'AI\u5b9f\u884c\u6570',
    fundingRate: '\u8cc7\u91d1\u8abf\u9054\u7387',
    totalTrades: '\u7dcf\u53d6\u5f15\u6570',
  },
  agents: {
    autonomousIntelligence: '\u81ea\u4e3b\u77e5\u80fd',
    aiTradingAgents: 'AI\u53d6\u5f15\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8',
    description:
      '\u6a5f\u68b0\u5b66\u7fd2\u6226\u7565\u306724\u6642\u9593\u53d6\u5f15\u3059\u308b\u81ea\u4e3b\u578bAI\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8\u3092\u30c7\u30d7\u30ed\u30a4\u3002\u5404\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8\u306f\u5b8c\u5168\u306b\u900f\u660e\u3067\u3001\u76e3\u67fb\u53ef\u80fd\u3067\u3001\u5b9f\u8df5\u3067\u691c\u8a3c\u6e08\u307f\u3067\u3059\u3002',
    pnl30d: 'PNL\uff0830\u65e5\uff09',
    winRate: '\u52dd\u7387',
    trades24h: '\u53d6\u5f15\u6570\uff0824h\uff09',
    avgHold: '\u5e73\u5747\u4fdd\u6709\u6642\u9593',
    risk: '\u30ea\u30b9\u30af',
    exploreAll: '\u5168\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8\u3092\u63a2\u7d22',
  },
  features: {
    productSuite: '\u88fd\u54c1\u7fa4',
    everythingNeed: '\u53d6\u5f15\u306b\u5fc5\u8981\u306a\u3059\u3079\u3066',
    description:
      '\u30d1\u30fc\u30da\u30c1\u30e5\u30a2\u30eb\u304b\u3089AI\u5b9f\u884c\u307e\u3067\u3001\u5b8c\u5168\u306a\u53d6\u5f15\u30a4\u30f3\u30d5\u30e9\u3002\u3059\u3079\u3066\u30aa\u30f3\u30c1\u30a7\u30fc\u30f3\u3067\u5b8c\u5168\u306b\u900f\u660e\u3067\u3059\u3002',
    learnMore: '\u8a73\u7d30\u3092\u898b\u308b',
  },
  dev: {
    developerFirst: '\u958b\u767a\u8005\u30d5\u30a1\u30fc\u30b9\u30c8',
    builtForBuilders: '\u30d3\u30eb\u30c0\u30fc\u306e\u305f\u3081\u306b\u69cb\u7bc9',
    description:
      '\u5b8c\u5168\u306aAPI\u30a2\u30af\u30bb\u30b9\u3001SDK\u3001\u30ea\u30a2\u30eb\u30bf\u30a4\u30e0WebSocket\u30d5\u30a3\u30fc\u30c9\u3002\u53d6\u5f15\u30dc\u30c3\u30c8\u3001\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8\u3001\u30ab\u30b9\u30bf\u30e0\u6226\u7565\u3092\u6570\u5206\u3067\u69cb\u7bc9\u3002',
    sdksAndApis: 'SDK\u3068API',
    restApi: 'REST API',
    websocket: 'WebSocket',
    pythonSdk: 'Python SDK',
    agentSdk: 'Agent SDK',
    tradingSdk: '\u53d6\u5f15SDK',
    viewDocs: '\u5b8c\u5168\u306a\u30c9\u30ad\u30e5\u30e1\u30f3\u30c8\u3092\u898b\u308b',
  },
  arch: {
    systemDesign: '\u30b7\u30b9\u30c6\u30e0\u8a2d\u8a08',
    dualEngine: '\u30c7\u30e5\u30a2\u30eb\u30a8\u30f3\u30b8\u30f3\u30a2\u30fc\u30ad\u30c6\u30af\u30c1\u30e3',
    description:
      '4\u3064\u306e\u5c02\u9580\u30a8\u30f3\u30b8\u30f3\u304c\u8abf\u548c\u3057\u3066\u52d5\u4f5c\u3057\u3001100ms\u672a\u6e80\u306e\u5b9f\u884c\u3068\u6a5f\u95a2\u30b0\u30ec\u30fc\u30c9\u306e\u4fe1\u983c\u6027\u3092\u63d0\u4f9b\u3002',
    aiEngine: 'AI\u30a8\u30f3\u30b8\u30f3',
    liquidityEngine: '\u6d41\u52d5\u6027\u30a8\u30f3\u30b8\u30f3',
    executionEngine: '\u5b9f\u884c\u30a8\u30f3\u30b8\u30f3',
    riskEngine: '\u30ea\u30b9\u30af\u30a8\u30f3\u30b8\u30f3',
    latency: '\u30ec\u30a4\u30c6\u30f3\u30b7',
    models: '\u30e2\u30c7\u30eb',
    depth: '\u6df1\u5ea6',
    pairs: '\u30da\u30a2',
    tps: 'TPS',
    uptime: '\u52d5\u4f5c\u7387',
    coverage: '\u30ab\u30d0\u30ec\u30c3\u30b8',
    alerts: '\u30a2\u30e9\u30fc\u30c8',
  },
  roadmap: {
    ourJourney: '\u79c1\u305f\u3061\u306e\u65c5',
    roadmap2026: '2026\u5e74\u30ed\u30fc\u30c9\u30de\u30c3\u30d7',
    description:
      'AI\u30cd\u30a4\u30c6\u30a3\u30d6\u53d6\u5f15\u30a4\u30f3\u30d5\u30e9\u306e\u672a\u6765\u3092\u3001\u4e00\u6b69\u305a\u3064\u69cb\u7bc9\u3057\u3066\u3044\u307e\u3059\u3002',
    completed: '\u5b8c\u4e86',
    inProgress: '\u9032\u884c\u4e2d',
    upcoming: '\u8fd1\u65e5\u516c\u958b',
  },
  footer: {
    product: '\u88fd\u54c1',
    developers: '\u958b\u767a\u8005',
    company: '\u4f1a\u793e',
    legal: '\u6cd5\u60c5',
    description:
      'AI\u30cd\u30a4\u30c6\u30a3\u30d6\u306a\u30aa\u30f3\u30c1\u30a7\u30fc\u30f3\u30d1\u30fc\u30da\u30c1\u30e5\u30a2\u30eb\u3001\u4e88\u6e2c\u5e02\u5834\u3001\u81ea\u4e3b\u5b9f\u884c\u306e\u305f\u3081\u306e\u53d6\u5f15\u30a4\u30f3\u30d5\u30e9\u3002',
    allRights: '\u5168\u3066\u306e\u6a29\u5229\u3092\u4fdd\u6709\u3002',
    systemsOperational: '\u3059\u3079\u3066\u306e\u30b7\u30b9\u30c6\u30e0\u304c\u6b63\u5e38\u306b\u52d5\u4f5c\u4e2d',
  },
  content: {
    agents: {
      scalper: {
        name: 'AI\u30b9\u30ad\u30e3\u30eb\u30d1\u30fc',
        description:
          '\u30dc\u30e9\u30c6\u30a3\u30ea\u30c6\u30a3\u6025\u4e0a\u6607\u6642\u306e\u6b21\u79d2\u4ee5\u4e0b\u306e\u5b9f\u884c\u3092\u884c\u3046\u9ad8\u983b\u5ea6\u52d5\u91cf\u53d6\u5f15',
      },
      'funding-arb': {
        name: '\u8cc7\u91d1\u8abf\u9054\u7387\u5957\u5229\u30dc\u30c3\u30c8',
        description:
          '\u30d1\u30fc\u30da\u30c1\u30e5\u30a2\u30eb\u4ea4\u63db\u3054\u3068\u306e\u8cc7\u91d1\u8abf\u9054\u7387\u5957\u5229\u3092\u81ea\u52d5\u5316',
      },
      'meme-hunter': {
        name: '\u30df\u30fc\u30e0\u30cf\u30f3\u30bf\u30fc',
        description:
          '\u30bd\u30fc\u30b7\u30e3\u30eb\u30bb\u30f3\u30c6\u30a3\u30e1\u30f3\u30c8\u5206\u6790\u3068\u30d0\u30a4\u30e9\u30eatoken\u306e\u65e9\u671f\u30a8\u30f3\u30c8\u30ea\u30fc',
      },
      'prediction-ai': {
        name: '\u4e88\u6e2cAI',
        description:
          '71%\u306e\u7cbe\u5ea6\u3067\u5e02\u5834\u65b9\u5411\u3092\u4e88\u6e2c\u3059\u308b\u6a5f\u68b0\u5b66\u7fd2\u30e2\u30c7\u30eb',
      },
      'whale-tracker': {
        name: '\u30db\u30a8\u30fc\u30eb\u30c8\u30e9\u30c3\u30ab\u30fc',
        description:
          '\u30aa\u30f3\u30c1\u30a7\u30fc\u30f3\u5206\u6790\u3067\u30b9\u30de\u30fc\u30c8\u30de\u30cd\u30fc\u3068\u30db\u30a8\u30fc\u30eb\u30a6\u30a9\u30ec\u30c3\u30c8\u3092\u8ffd\u8de1',
      },
    },
    features: {
      perpetual: {
        title: '\u30d1\u30fc\u30da\u30c1\u30e5\u30a2\u30eb\u53d6\u5f15',
        description:
          '\u6700\u592750\u500d\u30ec\u30d0\u30ec\u30c3\u30b8\u3001\u30bc\u30ed\u30b9\u30ea\u30c3\u30da\u30fc\u30b8\u306e\u5b8c\u5168\u30aa\u30f3\u30c1\u30a7\u30fc\u30f3\u30d1\u30fc\u30da\u30c1\u30e5\u30a2\u30eb\u5148\u7269',
      },
      'ai-execution': {
        title: 'AI\u5b9f\u884c',
        description:
          'AI\u30d1\u30ef\u30fc\u30c9\u306e\u6ce8\u6587\u30eb\u30fc\u30c6\u30a3\u30f3\u30b0\u3068\u5168\u5e02\u5834\u3067\u306e\u6700\u9069\u30a8\u30f3\u30c8\u30ea\u30fc\u30bf\u30a4\u30df\u30f3\u30b0',
      },
      prediction: {
        title: '\u4e88\u6e2c\u5e02\u5834',
        description:
          '\u6697\u53f7\u901a\u8ca8\u7d50\u679c\u306e\u5373\u6642\u6c7a\u6e08\u4ed8\u304d\u3001\u5206\u6563\u578b\u4e88\u6e2c\u5e02\u5834',
      },
      'copy-trading': {
        title: '\u30b3\u30d4\u30fc\u53d6\u5f15',
        description:
          '\u30c8\u30c3\u30d7\u30d1\u30d5\u30a9\u30fc\u30de\u30b9AI\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8\u3068\u8a8d\u8a3c\u53d6\u5f15\u8005\u3092\u30ef\u30f3\u30af\u30ea\u30c3\u30af\u3067\u30d5\u30a9\u30ed\u30fc',
      },
      hyperevm: {
        title: 'HyperEVM',
        description:
          'Ethereum\u3001Solana\u3001Arbitrum\u3001Base\u306b\u8de8\u308b\u30de\u30eb\u30c1\u30c1\u30a7\u30fc\u30f3\u5c55\u958b',
      },
      vault: {
        title: '\u30b9\u30c8\u30e9\u30c6\u30b8\u30fc\u91d1\u5eab',
        description:
          '\u5185\u8535\u30ea\u30b9\u30af\u7ba1\u7406\u4ed8\u304d\u81ea\u52d5\u53ce\u76ca\u751f\u6210\u30b9\u30c8\u30e9\u30c6\u30b8\u30fc',
      },
    },
    engines: {
      'ai-engine': {
        name: 'AI\u30a8\u30f3\u30b8\u30f3',
        description:
          '\u30b7\u30b0\u30ca\u30eb\u751f\u6210\u3001\u30d1\u30bf\u30fc\u30f3\u8a8d\u8b58\u3001\u4e88\u6e2c\u30e2\u30c7\u30ea\u30f3\u30b0\u306e\u305f\u3081\u306e\u30cb\u30e5\u30fc\u30e9\u30eb\u30cd\u30c3\u30c8\u30ef\u30fc\u30af',
      },
      'liquidity-engine': {
        name: '\u6d41\u52d5\u6027\u30a8\u30f3\u30b8\u30f3',
        description:
          '\u6df1\u3044\u6ce8\u6587\u7c3f\u96c6\u7d04\u3068\u30af\u30ed\u30b9\u30c1\u30a7\u30fc\u30f3\u6d41\u52d5\u6027\u30eb\u30fc\u30c6\u30a3\u30f3\u30b0',
      },
      'execution-engine': {
        name: '\u5b9f\u884c\u30a8\u30f3\u30b8\u30f3',
        description:
          'MEV\u4fdd\u8b77\u3068\u6700\u9069\u30eb\u30fc\u30c6\u30a3\u30f3\u30b0\u3092\u5099\u3048\u305f100ms\u672a\u6e80\u306e\u6ce8\u6587\u5b9f\u884c',
      },
      'risk-engine': {
        name: '\u30ea\u30b9\u30af\u30a8\u30f3\u30b8\u30f3',
        description:
          '\u30ea\u30a2\u30eb\u30bf\u30a4\u30e0\u30dd\u30b8\u30b7\u30e7\u30f3\u76e3\u8996\u3001\u6e05\u7b97\u4fdd\u8b77\u3001\u30dd\u30fc\u30c8\u30d5\u30a9\u30ea\u30aa\u30d8\u30c3\u30b8',
      },
    },
    roadmap: {
      q1: {
        title: 'Beta\u30ea\u30ea\u30fc\u30b9',
        items: [
          'AI Agents v1\u30015\u7a2e\u306e\u6226\u7565',
          '\u30d1\u30fc\u30da\u30c1\u30e5\u30a2\u30eb\u53d6\u5f15\u30e1\u30a4\u30f3\u30cd\u30c3\u30c8',
          'WebSocket\u30ea\u30a2\u30eb\u30bf\u30a4\u30e0API',
          '\u30af\u30ed\u30b9\u30c1\u30a7\u30fc\u30f3\u30d6\u30ea\u30c3\u30b8\u7d71\u5408',
        ],
      },
      q2: {
        title: '\u30e1\u30a4\u30f3\u30cd\u30c3\u30c8\u62e1\u5f35',
        items: [
          '\u4e88\u6e2c\u5e02\u5834\u30ea\u30ea\u30fc\u30b9',
          'Python & TypeScript SDK',
          '\u30e2\u30d0\u30a4\u30eb\u53d6\u5f15\u30a2\u30d7\u30eaBeta',
          '\u6a5f\u95a2\u30b0\u30ec\u30fc\u30c9API\u30a2\u30af\u30bb\u30b9',
        ],
      },
      q3: {
        title: '\u30a8\u30b3\u30b7\u30b9\u30c6\u30e0\u6210\u9577',
        items: [
          '\u30b9\u30c8\u30e9\u30c6\u30b8\u30fc\u91d1\u5eab\u30ea\u30ea\u30fc\u30b9',
          '\u30b3\u30d4\u30fc\u53d6\u5f15\u30d7\u30e9\u30c3\u30c8\u30d5\u30a9\u30fc\u30e0',
          'HyperEVM\u30de\u30eb\u30c1\u30c1\u30a7\u30fc\u30f3',
          '\u30ac\u30d0\u30ca\u30f3\u30b9\u30d5\u30ec\u30fc\u30e0\u30ef\u30fc\u30af',
        ],
      },
      q4: {
        title: '\u5b8c\u5168\u5206\u6563\u5316',
        items: [
          'ZhiSu\u30c8\u30fc\u30af\u30f3\u30ea\u30ea\u30fc\u30b9',
          'DAO\u30ac\u30d0\u30ca\u30f3\u30b9',
          'Layer 2\u30b9\u30b1\u30fc\u30ea\u30f3\u30b0',
          'AI\u30e2\u30c7\u30eb\u30de\u30fc\u30b1\u30c3\u30c8\u30d7\u30ec\u30a4\u30b9',
        ],
      },
    },
    riskLevels: {
      high: '\u9ad8',
      low: '\u4f4e',
      veryHigh: '\u975e\u5e38\u306b\u9ad8\u3044',
      medium: '\u4e2d',
    },
    footerLinks: {
      product: ['\u5e02\u5834', 'AI\u30a8\u30fc\u30b8\u30a7\u30f3\u30c8', '\u91d1\u5eab', '\u30e9\u30f3\u30ad\u30f3\u30b0', '\u624b\u6570\u6599'],
      developers: ['API\u53c2\u7167', 'SDK'],
      company: ['\u4f1a\u793e\u6982\u8981', '\u63a1\u7528\u60c5\u5831', '\u30d7\u30ec\u30b9', '\u30d6\u30e9\u30f3\u30c9\u30ac\u30a4\u30c9', '\u304a\u554f\u3044\u5408\u308f\u305b'],
      legal: ['\u5229\u7528\u898f\u7d04', '\u30d7\u30e9\u30a4\u30d0\u30b7\u30fc\u30dd\u30ea\u30b7\u30fc', 'Cookie\u30dd\u30ea\u30b7\u30fc', 'AML\u65b9\u91dd', '\u30ea\u30b9\u30af\u958b\u793a', '\u30e6\u30fc\u30b6\u30fc\u898f\u7d04'],
    },
    timeAgo: '{{time}}\u79d2\u524d',
  },
};